import React from 'react'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Community = () => {
   const eventData = useSelector((state) => state.event.eventData || {});
        const backgroundImage = eventData.people.imageKey;
        const community = eventData.community;
  return (
    <div>
         <section class="tour-area position-relative bg-top-center overflow-hidden space" id="service-sec"
 style={{
    backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
  
   >
 
 <div class="container" >
     <div class="row">
         <div class="col-lg-6 offset-lg-3" >
             <div class="title-area text-center">
             <span class="sub-title"> {community.Heading}</span>

                 <h2 class="sec-title">{community.Subheading}</h2>
             </div>
           
         </div>
     </div>
     
 </div>

</section>
     <section class="tour-area position-relative bg-top-center overflow-hidden space" id="service-sec" style={{ background: "rgb(62, 222, 13)" }}>
     
        <div class="container" style={{background:"white", borderRadius:"15px"}}>
            <div class="row">
                <div class="col-lg-6 offset-lg-3">
                    <div class="title-area text-center" style={{marginTop:"55px"}}>
                        <span class="sub-title">Join Our Official WhatsApp Community</span>
                        <p class="sec-text">Join our thriving community of drone enthusiasts, pilots, and professionals</p>
                        <div className="header-button" style={{justifyContent:"center"}}>
                     
                     <Link to="/community" className="th-btn">
                     Join WhatsApp Community
                     </Link>
                   </div>
                    </div>
                    
                </div>
            </div>
            
        </div>

    </section>
   
    </div>
  )
}

export default Community
